import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.825 6.91248L10 10.7291L6.175 6.91248L5 8.08748L10 13.0875L15 8.08748L13.825 6.91248Z",
			fill: "#323232"
		})
	})
});
export default SvgExpandArrow;
